import { createApp } from 'vue'
import Toast from '../components/Toast.vue'

let toastInstance = null

const showToast = (message, type = 'info', duration = 3000) => {
  // 如果已有 Toast，先移除
  if (toastInstance) {
    toastInstance.unmount()
    toastInstance = null
  }

  // 创建容器
  const container = document.createElement('div')
  document.body.appendChild(container)

  // 创建 Toast 实例
  toastInstance = createApp(Toast, {
    message,
    type,
    duration,
    onClose: () => {
      if (toastInstance) {
        toastInstance.unmount()
        document.body.removeChild(container)
        toastInstance = null
      }
    }
  })

  toastInstance.mount(container)
}

export const toast = {
  success(message, duration) {
    showToast(message, 'success', duration)
  },
  error(message, duration) {
    showToast(message, 'error', duration)
  },
  info(message, duration) {
    showToast(message, 'info', duration)
  }
}

export default toast

